<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Riders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.products.deals.index')">
                                    Riders
                                </Link>
                            </li>
                            <li class="breadcrumb-item active"> {{ isEditing ? "Edit" : "Add" }} Rider
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form @submit.prevent="saveRider">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rider First Name</label>
                                        <input type="text" v-model="rider.first_name" class="form-control"
                                               placeholder="Rider First Name"
                                               required>
                                        <div v-if="rider.errors.first_name" class="text-danger text-small">
                                            {{ rider.errors.first_name }}
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="form-group">-->
<!--                                    <div class="controls">-->
<!--                                        <label>Rider Email</label>-->
<!--                                        <input type="text" v-model="rider.email" class="form-control"-->
<!--                                               placeholder="Rider Email"-->
<!--                                               required>-->
<!--                                        <div v-if="rider.errors.email" class="text-danger text-small">-->
<!--                                            {{ rider.errors.email }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rider Plate No</label>
                                        <input type="text" v-model="rider.plate_no" class="form-control"
                                               placeholder="Rider Plate No"
                                               required>
                                        <div v-if="rider.errors.plate_no" class="text-danger text-small">
                                            {{ rider.errors.plate_no }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Store</label>
                                        <select v-model="rider.store_id" id="" class="form-control" required>
                                            <option value="" selected>Select the Rider's Store</option>
                                            <option v-for="store in stores" :key="store.id" :value="store.id">
                                                {{ store.name }}
                                            </option>
                                        </select>

                                        <span v-if="rider.errors.store_id"
                                              class="text-danger text-small">{{
                                                rider.errors.store_id
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rider Last Name</label>
                                        <input type="text" v-model="rider.last_name" class="form-control"
                                               placeholder="Rider Last Name"
                                               required>
                                        <div v-if="rider.errors.last_name" class="text-danger text-small">
                                            {{ rider.errors.last_name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rider Phone Number</label>
                                        <input type="text" v-model="rider.phone" class="form-control"
                                               placeholder="Rider Phone Number"
                                               required>
                                        <div v-if="rider.errors.phone" class="text-danger text-small">
                                            {{ rider.errors.phone }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rider Password</label>
                                        <input type="text" v-model="rider.password" class="form-control"
                                               placeholder="Rider Password" :required="!isEditing">
                                        <div v-if="rider.errors.password" class="text-danger text-small">
                                            {{ rider.errors.password }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck2"
                                                   v-model="rider.is_active" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck2">
                                                Is this Rider Active?
                                            </label>
                                        </div>
                                        <span v-if="rider.errors.is_active"
                                              class="text-danger text-small">{{ rider.errors.is_active }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";

export default {
    metaInfo: {title: 'Create Riders'},
    name: 'RiderCreate',
    props: [
        'stores',
        'isEditing',
        'riderData',
    ],
    components: {
        Link,
    },
    layout: Layout,
    data() {
        return {
            rider: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                plate_no: null,
                password: null,
                store_id: "",
                is_active: false,
            }),
            saving: false
        }
    },
    methods: {
        async saveRider() {
            this.saving = true;

            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            if (this.isEditing) {
                this.rider.post(route('admin.riders.update', this.riderData.id), options);
            } else {
                this.rider.post(route('admin.riders.store'), options);
            }

        }
    },
    mounted() {
        if (this.isEditing) {
            this.rider.first_name = this.riderData.first_name;
            this.rider.last_name = this.riderData.last_name;
            this.rider.email = this.riderData.email;
            this.rider.phone = this.riderData.phone;
            this.rider.plate_no = this.riderData.plate_no;
            this.rider.store_id = this.riderData.store_id;
            this.rider.is_active = this.riderData.is_active;
        }
        console.log(this.stores);
    },
}
</script>
